import React from 'react';
import { withNotifications } from './NotificationsContext';
import { Dagger } from './NotificationsTrigger';
import Currency from '../intl/Currency';

const PriceWithDisclaimer = (props) => {
  const {
    className,
    value,
    disclaimer,
    notifications,
    useModal = false,
  } = props;
  const { disabled, show } = notifications;

  const normalizedClassName = className || '';

  if (disabled) {
    return (
      <span className={normalizedClassName}>
        <Currency value={value} />
      </span>
    );
  }

  return (
    <React.Fragment>
      <span
        onClick={(event) =>
          useModal
            ? show(disclaimer, event, null, true)
            : show(disclaimer, event)
        }
        className={`disclaimer ${normalizedClassName}`}>
        <Currency value={value} /> <Dagger />
      </span>
      <div className="show-for-sr">{disclaimer}</div>
    </React.Fragment>
  );
};

export default withNotifications(PriceWithDisclaimer);
